module.exports = __webpack_public_path__ + "static/media/LogoGif.6d1c14da.gif";